import type { QueryClient } from '@tanstack/react-query'
import {
  getGetReportsImpactQueryKey,
  getGetReportsMarketingQueryKey,
  getGetReportsOverviewQueryKey,
} from '@/api/generated/reports/reports'

/**
 * Refreshes the Reports pages that read campaigns, ad spend and ROAS (Marketing, Overview, Hayven's impact) after a
 * Marketing write. Their 5-minute stale time would otherwise keep the old spend on screen. The bare generated keys
 * are prefixes of every `?period=` + salon variant.
 */
export function invalidateMarketingBackedReports(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: getGetReportsMarketingQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getGetReportsOverviewQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getGetReportsImpactQueryKey() }),
  ])
}
